// buyPaymentFlowService.js
// Handles payment flow logic for TbGlobalPaymentsPage

import {
  convertQuoteIntoPolicy,
  fetchPclAgreementUrl,
} from "../services/buyService";
import useBuyStore from "../store/BuyStore";
import useQuoteStore from "../../quote/store/QuoteStore";
import { TAXI_QUOTE_BRANDREF } from "../../../config/config";

export async function convertQuoteIntoPolicyNew(
  paymentResponse,
  navigate,
  setValue,
  watch
) {
  const brandRef = TAXI_QUOTE_BRANDREF;
  const buyStore = useBuyStore.getState();
  const quoteStore = useQuoteStore.getState();
  const selectedPaymentOption = buyStore.getObject("selectedPaymentOption");
  const riskObjectId = quoteStore.quote?.risk?.riskObjectId ?? "";
  const quoteAddress = quoteStore.quote?.risk?.drivers[0]?.address;

  const quoteData = {
    BrandRef: brandRef,
    RiskObjectId: riskObjectId,
    RiskObjectHistoryId: 1,
    SelectedPaymentPlanId: selectedPaymentOption?.paymentOptionId,
    CardPaymentTakenAmount:
      selectedPaymentOption?.deposit ||
      selectedPaymentOption?.totalAmountToPayByCustomer,
    responseJson: JSON.stringify(paymentResponse),
  };

  if (selectedPaymentOption?.deposit) {
    // If it has deposit, it's monthly payment
    const directDebitDetails = buyStore.getObject("directDebitDetails");
    quoteData.DirectDebitDetails = {
      Sortcode: directDebitDetails?.sortCodeFormatted,
      AccountN0: directDebitDetails?.accountNumber,
      AccountHolderName: directDebitDetails?.accountName,
      AddressLine1: quoteAddress
        ? [quoteAddress.houseNo, quoteAddress.street, quoteAddress.city]
            .filter(Boolean)
            .join(", ")
        : "",
      Postcode: quoteAddress?.postcode ?? "",
      AccountHolderSameAsPolicyHolder: true,
      AddressSameAsPolicyHolder: true,
    };
  }

  try {
    const data = await convertQuoteIntoPolicy(quoteData, navigate);
    buyStore.setObject("paymentSuccessResponse", JSON.stringify(data));
    buyStore.setObject(
      "isFinanceAgreementAvailable",
      data.IsFinanceAgreementAvailable
    );
    setValue && setValue("paymentSuccessResponse", JSON.stringify(data));
    setValue &&
      setValue(
        "PclMessageTransmitted",
        JSON.stringify(data.PclMessageTransmitted)
      );
    setValue &&
      setValue("isFinanceAgreementAvailable", data.IsFinanceAgreementAvailable);

    if (data) {
      setValue && setValue("DisablePrevbtn", true);
      setValue && setValue("QuoteIntopolicySuccessful", true);
    }

    const paymentSuccessResponse = watch
      ? watch("paymentSuccessResponse")
      : undefined;
    const selectedOption = selectedPaymentOption?.deposit
      ? "monthly"
      : "annual";

    const dataToStore = {
      paymentSuccessResponse,
      riskObjectId,
      selectedOption,
    };

    buyStore.setObject("buyJourneyData", JSON.stringify(dataToStore));
    return {
      quoteData,
      isFinanceAgreementAvailable: data.IsFinanceAgreementAvailable,
    };
  } catch (error) {
    console.error("Error converting quote into policy:", error);
    throw error;
  }
}

export async function determineNextStepForTbGlobalPayments(
  navigate,
  setValue,
  watch
) {
  const buyStore = useBuyStore.getState();
  const paymentResponse = buyStore.getObject("globalPaymentsResponse");
  if (paymentResponse) {
    const {
      quoteData,
      isFinanceAgreementAvailable,
    } = await convertQuoteIntoPolicyNew(
      paymentResponse,
      navigate,
      setValue,
      watch
    );
    if (
      buyStore.getObject("selectedPaymentOption")?.deposit &&
      isFinanceAgreementAvailable === true
    ) {
      await fetchPclAgreementUrl(quoteData, navigate);
    }
    navigate(`/payment/success`);
  }
}

export function handlePaymentSuccess(
  response,
  navigate,
  setPaymentProcessLoading,
  setValue,
  watch
) {
  const buyStore = useBuyStore.getState();
  buyStore.setObject("globalPaymentsResponse", response);
  setPaymentProcessLoading(true);
  determineNextStepForTbGlobalPayments(navigate, setValue, watch);
}
